import ActionTypes from '../constants';

const initialState = {
    drivingLicenses: {},
    drivingLicense: {},
    drivingLicenseId: {},
    // loading: false,
};

const drivingLicenseReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETDRIVINGLICENSESUCCESS:
            return {
                ...state,
                drivingLicenses: action.payload,
            }
        case ActionTypes.GETDRIVINGLICENSEBYIDSUCCESS:
            return {
                ...state,
                drivingLicense: action.payload,
            }
        case ActionTypes.SAVEDRIVINGLICENSESUCCESS:
            return {
                ...state,
                drivingLicenseId: action.payload,
            }
        default:
            return state;
    }
}

export default drivingLicenseReducer;